export default __webpack_public_path__ + "media/lang_icon.690ddd2b.svg";